"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchInput = exports.SearchIcon = exports.ClearButton = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const SearchInput = exports.SearchInput = (0, _mui.styled)(_mui.TextField)((param)=>{
    let { theme } = param;
    return {
        [".".concat(_mui.inputBaseClasses.root)]: {
            background: theme.palette.grey[100],
            color: theme.palette.text.primary
        },
        [".".concat(_mui.inputBaseClasses.input)]: {
            padding: theme.spacing(2, 0),
            '&::placeholder': {
                color: theme.palette.grey.A700
            }
        }
    };
});
const ClearButton = exports.ClearButton = (0, _mui.styled)(_icons.Clear)({
    cursor: 'pointer'
});
const SearchIcon = exports.SearchIcon = (0, _mui.styled)(_icons.Search)((param)=>{
    let { theme } = param;
    return {
        marginRight: 14,
        color: theme.palette.text.primary,
        [theme.breakpoints.down('sm')]: {
            marginRight: 6
        }
    };
});
